import * as types from '../actions/loadingState/types';


const INITIAL_STATE = {
  loading: false,
};

export default function fullPageLoadingStateReducer(state = INITIAL_STATE, action) {

  switch(action.type) {
    case types.FULL_PAGE_LOADING_STATE:

      return action.payload;

    default: return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/fullPageLoadingStateReducer.js